jQuery( document ).ready(function() {
	// Check if component is added to the page
    if( jQuery('section.text-content').length ) {
        
    }
});